import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { LocationLegacyComponent } from './location.component';

@NgModule({
  entryComponents: [
    LocationLegacyComponent
  ],
  declarations: [
    LocationLegacyComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressBarModule
  ],
  exports: [
    LocationLegacyComponent
  ]
})
export class LocationLegacyModule { }
